import { createApp } from 'vue';
import groupReserve from '../vue-component/groupReserve.vue';

const app = createApp({});
app.component('group-reserve', groupReserve);
app.mount('#app')
